<template>
  <b-card style="padding:40px;">
    <h5><b>STOCKOUT</b></h5>
    <hr />
    <div>
      <b-row>
        <b-col md="3">
          <b-form-group>
            <label :for="`input-size`"
              >Outlet Category <span class="danger-new"> *</span></label
            >
            <b-form-select
              v-model="form.outlet_cat"
              :options="outlet_cat"
              class="input-new"
              required
              @change="changeOutlet"
              :disabled="!ui.stockUp"
            />
            <p v-if="error.outlet_cat">
              <span class="danger-new">{{ this.error.outlet_cat }}</span>
            </p>
          </b-form-group>
        </b-col>

        <b-col md="3" v-if="selectOutlet.suboutlet_cat.length >= 2">
          <b-form-group>
            <label :for="`input-size`"
              >Sub Outlet Category<span class="danger-new"> *</span></label
            >
            <b-form-select
              v-model="form.suboutlet_cat"
              :options="selectOutlet.suboutlet_cat"
              class="input-new"
              v-if="!isLoading"
              required
              :disabled="!ui.stockUp"
            />
            <p v-if="error.sub_outlet_cat">
              <span class="danger-new">{{ this.error.sub_outlet_cat }}</span>
            </p>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group>
            <span v-if="chooseType == '1'">
              <label :for="`input-name`"
                >Outlet Name <span class="danger-new"> *</span></label
              >
              <b-form-input
                v-model="form.outlet_name"
                :id="`input-name`"
                :type="`text`"
                class="input-new"
                required
                :disabled="!ui.stockUp"
              ></b-form-input>
            </span>
            <span v-if="chooseType == '2'">
              <label :for="`input-name`"
                >Select Outlet Name <span class="danger-new"> *</span></label
              >
              <multiselect
                v-model="form.outlet_name"
                :options="select"
                placeholder="Please select"
                :disabled="!ui.stockUp"
                @input="changeOutletInfo"
              ></multiselect>
            </span>
            <p v-if="error.outlet_name">
              <span class="danger-new">{{ this.error.outlet_name }}</span>
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <br />

      <b-row>
        <b-col md="4" v-if="selectOutlet.typeoutlet.length >= 2">
          <b-form-group>
            <label :for="`input-size`"
              >Category Type<span class="danger-new"> *</span></label
            >
            <b-form-select
              v-model="form.typeoutlet"
              :options="selectOutlet.typeoutlet"
              required
              class="input-new"
              :disabled="!ui.stockUp"
            />
            <p v-if="error.typeoutlet">
              <span class="danger-new">{{ this.error.typeoutlet }}</span>
            </p>
          </b-form-group>
        </b-col>

        <b-col md="4" v-if="form.outlet_cat === 6">
          <b-form-group>
            <label :for="`input-size`"
              >ID Number<span class="danger-new"> *</span></label
            >
            <b-form-input
              v-model="form.idno"
              id="input-horizontal"
              type="text"
              class="input-new"
              required
              :disabled="!ui.stockUp"
            ></b-form-input>
            <p v-if="error.idno">
              <span class="danger-new">{{ this.error.idno }}</span>
            </p>
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group>
            <label :for="`input-role`">Chiller</label>
            <b-form-radio-group
              v-model="form.chiller"
              :options="chiller"
              plain
              size="xl"
              name="plain-inline"
              :disabled="!ui.stockUp"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1 variant="info"
              >Outlet Detail</b-button
            >
          </b-card-header>
          <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Company Name</label>
                    <b-form-input
                      v-model="form.compName"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="4">
                  <b-form-group>
                    <label :for="`input-role`">Credit Term</label>
                    <b-form-input
                      v-model="form.credit_terms"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="4">
                  <b-form-group>
                    <label :for="`input-role`">Fax No.</label>
                    <b-form-input
                      v-model="form.faxno"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <label :for="`input-role`">Tel No.</label>
                    <b-form-input
                      v-model="form.telno"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Shipping Address 1</label>
                    <b-form-input
                      v-model="form.add1"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Shipping Address 2</label>
                    <b-form-input
                      v-model="form.add2"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Shipping Address 3</label>
                    <b-form-input
                      v-model="form.add3"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-checkbox
                id="checkbox-1"
                v-model="ship_bill"
                name="checkbox-1"
                @change="shipToBill()"
              >
                If Shipping Address is same with Billing Address
              </b-form-checkbox>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Billing Address 1</label>
                    <b-form-input
                      v-model="form.billAdd1"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Billing Address 2</label>
                    <b-form-input
                      v-model="form.billAdd2"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Billing Address 3</label>
                    <b-form-input
                      v-model="form.billAdd3"
                      type="text"
                      class="input-new"
                      :disabled="!ui.stockUp"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label :for="`input-role`">Notes</label>
                    <b-form-textarea
                      v-model="form.notes"
                      class="input-new"
                      rows="3"
                      max-rows="6"
                      :disabled="!ui.stockUp"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <b-row>
        <b-col md="4">
          <b-form-group>
            <label :for="`input-size`"
              >Date<span class="danger-new"> *</span></label
            >
            <b-form-input
              v-model="form.date"
              id="input-horizontal"
              type="date"
              class="input-new"
              placeholder="DD/MM/YYYY"
              required
              :min="minDate"
              @blur="getDate()"
              :disabled="!ui.stockUp || disableDate"
            ></b-form-input>

            <p v-if="error.date">
              <span class="danger-new">{{ this.error.date }}</span>
            </p>

            <p>
              <i
                ><b>Date format: DD/MM/YYYY</b><br />If date is 1st December
                2020: 01/12/2020. We recommend to use Mozilla Firefox & Google
                Chrome</i
              >
            </p>
          </b-form-group>
        </b-col>
        <b-col align="right" style="padding-top:27px;">
          <b-button variant="primary" size="m" @click="onClickEdit"
            >EDIT</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="primary"
            size="m"
            @click.prevent="onClickSave('save')"
            >SAVE</b-button
          >
        </b-col>
      </b-row>

      <hr />
      <br />
      <b-row>
        <b-col md="8">
          <label for="input-default"
            >Product Name<span class="danger-new"> *</span></label
          >
          <multiselect
            v-model="input.product_name"
            :options="product_name"
            :custom-label="nameWithSKU"
            placeholder="Please select"
            label="name"
            track-by="name"
            :disabled="ui.stockUp"
          ></multiselect>
          <p v-if="error.product_name">
            <span class="danger-new">{{ this.error.product_name }}</span>
          </p>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="3">
          <label for="input-default"
            >Quantity<span class="danger-new"> *</span></label
          >
          <b-form-input
            v-model="input.qty"
            id="input-horizontal"
            type="number"
            class="input-new"
            required
            :disabled="ui.stockUp"
          />
          <p v-if="error.qty">
            <span class="danger-new">{{ this.error.qty }}</span>
          </p>
        </b-col>

        <b-col md="3">
          <label for="input-default"
            >Quantity Type<span class="danger-new"> *</span></label
          >
          <b-form-select
            v-model="input.qtyType"
            :options="dropdown.qtyType"
            required
            class="input-new"
            :disabled="ui.stockUp"
          />
        </b-col>

        <b-col md="3">
          <label for="input-default"
            >Price (RM)<span class="danger-new"> *</span></label
          >
          <b-form-input
            v-model="input.price"
            id="input-horizontal"
            type="number"
            class="input-new"
            required
            :disabled="ui.stockUp"
          />
          <p v-if="error.price">
            <span class="danger-new">{{ this.error.price }}</span>
          </p>
        </b-col>

        <b-col md="2" style="padding-top:27px;" v-if="!ui.stockUp">
          <b-button variant="primary" size="m" @click="onClickAdd('add')"
            >+</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button variant="danger" size="m" @click="onClickClear()"
            >x</b-button
          >
        </b-col>
      </b-row>
      <br />
    </div>

    <br />
    <TableStockoutCreate
      @delete="deleteItem($event)"
      :grand="parseFloat(grandP)"
      :fields="fields"
      :items="items"
    />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="m" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="m" @click="onClickPreview"
          >PREVIEW</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import TableStockoutCreate from "@/table/user/stockout/TableStockoutCreate";
import Multiselect from "vue-multiselect";
import itemTemplate from "./item-template.vue";
import moment from "moment";

export default {
  components: {
    Multiselect,
    TableStockoutCreate
  },
  data() {
    return {
      grandP: "0",
      item: {},
      select: [],
      outletHistory: [],
      itemTemplate,
      items: [],
      form: {
        stock_id: null,
        outlet_name: "",
        outlet_cat: "",
        suboutlet_cat: "",
        items: "",
        id: "",
        idno: "",
        date: "",
        category: "",
        typeoutlet: "",
        chiller: "",
        faxno: "",
        telno: "",
        add1: "",
        add2: "",
        add3: "",
        billAdd1: "",
        billAdd2: "",
        billAdd3: "",
        compName: "",
        credit_terms: "",
        accno: "",
        notes: ""
      },

      ship_bill: false,

      outlet_cat: [{ text: "Please Select", value: "" }],
      suboutlet_cat: [{ text: "Please Select", value: "" }],
      typeoutlet: [{ text: "Please Select", value: "" }],
      selectOutlet: {
        suboutlet_cat: [{ text: "Please Select", value: "" }],
        typeoutlet: [{ text: "Please Select", value: "" }]
      },
      product_name: [],
      selected: null,
      input: {
        product_name: [],
        qty: "",
        qtyType: "1",
        price: ""
      },
      error: {
        outlet_cat: "",
        sub_outlet_cat: "",
        outlet_name: "",
        date: "",
        product_name: "",
        qty: "",
        qtyType: "",
        price: "",
        idno: "",
        typeoutlet: ""
      },

      chiller: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
      ],
      dropdown: {
        qtyType: [
          { text: "Pcs", value: "1" },
          { text: "Ctn", value: "2" }
        ]
      },
      ui: {
        stockUp: true
      },

      // Outlet enter type
      chooseType: "2",
      nameType: "Select Outlet",
      disableBtn: false,

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "product_name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        },
        {
          label: "Price (RM)",
          key: "price",
          sortable: false
        },
        {
          label: "Total Price (RM)",
          key: "totalprice",
          sortable: false
        },
        {
          label: "Action",
          key: "action",
          sortable: false
        }
      ],

      isSafari: false,
      disableDate: false,
      minDate: moment().format("YYYY-MM-DD"),
      isLoading: false
    };
  },
  computed: {
    totalPrice: function() {
      return this.input.qty * this.input.price;
    }
  },
  created() {
    this.isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && window["safari"].pushNotification)
      );

    if (this.$route.query.type !== undefined) {
      localStorage.removeItem("data_stockout");
    }
    if (this.$route.query.type === "update") {
      this.disableDate = true;
    } else {
      this.getCompanyName();
    }

    let todayDate = moment().format("YYYY-MM-DD");
    let year = moment(todayDate).year();
    let month = moment(todayDate).month() + 1;

    if (this.isSafari) {
      if (month < 10) {
        month = "0" + month;
      }
    }

    let checkYear = moment(year + "-" + month + "-" + "05").format(
      "YYYY-MM-DD"
    );

    if (todayDate >= checkYear) {
      this.minDate = moment(year + "-" + month + "-" + "01").format(
        "YYYY-MM-DD"
      );
    } else {
      if (month == "01") {
        let newYear = year - 1;
        this.minDate = moment(newYear + "-" + "12" + "-" + "01").format(
          "YYYY-MM-DD"
        );
      } else {
        let newMonth = month - 1;
        this.minDate = moment(year + "-" + newMonth + "-" + "01").format(
          "YYYY-MM-DD"
        );
      }
    }

    this.getProduct();
    this.getOutletNameHistory();
    // this.showStockout();
    this.getOutlet();
  },
  methods: {
    onClickEdit() {
      this.ui.stockUp = true;
    },

    getCompanyName() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$store.getters.getUser_id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            // this.form.compName = res.data.data.company;
            this.form.credit_terms = res.data.data.credit_terms;
            this.form.accno = res.data.data.accno;
          }
        });
    },

    getDate() {
      let date = this.form.date;
      let curDate = moment(date, "DD/MM/YYYYY").format("YYYY-MM-DD");

      if (date.length > 10) {
        this.form.date = moment(new Date()).format("YYYY-MM-DD");
      }

      if (this.isSafari) {
        if (date.length !== 10) {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          // return;
        }
        if (date.slice(3, 4) !== "/" && date.slice(5, 6) !== "/") {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          // return;
        }
        if (moment(curDate).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
        }
      } else {
        if (moment(date).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
        }
      }
    },

    shipToBill() {
      if (this.ship_bill === true) {
        this.form.billAdd1 = "";
        this.form.billAdd2 = "";
        this.form.billAdd3 = "";
      } else {
        this.form.billAdd1 = this.form.add1;
        this.form.billAdd2 = this.form.add2;
        this.form.billAdd3 = this.form.add3;
      }
    },

    onClickSave(data) {
      this.checkForm(data);

      let date = this.form.date;

      if (this.isSafari) {
        if (date.length !== 10) {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          return;
        }
        if (date.slice(3, 4) !== "/" && date.slice(5, 6) !== "/") {
          alert("Your date format is wrong (DD/MM/YYYY)!");
          return;
        }

        date = moment(date, "DD/MM/YYYYY").format("YYYY-MM-DD");

        if (moment(date).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
          return;
        }
      } else {
        if (moment(date).diff(moment(this.minDate), "days") < 0) {
          alert("Your date exceed minimum date:" + this.minDate);
          return;
        }
      }

      let price = this.input.price ? parseFloat(this.input.price) : null;
      let form = {};
      if (price === null) {
        form = {
          stock_id: this.form.stock_id,
          outlet_name: this.form.outlet_name,
          outlet_id: this.form.outlet_cat,
          sub_outlet_id: this.form.suboutlet_cat,
          sub_outlet_type: this.form.typeoutlet,
          chiller: this.form.chiller,
          date: date,
          idno: this.form.idno,
          faxno: this.form.faxno,
          telno: this.form.telno,
          add1: this.form.add1,
          add2: this.form.add2,
          add3: this.form.add3,
          notes: this.form.notes,
          company_add1: this.form.billAdd1,
          company_add2: this.form.billAdd2,
          company_add3: this.form.billAdd3,
          company_name: this.form.compName,
          credit_terms: this.form.credit_terms,
          accno: this.form.accno
        };
      } else {
        form = {
          stock_id: this.form.stock_id,
          outlet_name: this.form.outlet_name,
          outlet_id: this.form.outlet_cat,
          sub_outlet_id: this.form.suboutlet_cat,
          sub_outlet_type: this.form.typeoutlet,
          chiller: this.form.chiller,
          date: date,
          idno: this.form.idno,
          faxno: this.form.faxno,
          telno: this.form.telno,
          add1: this.form.add1,
          add2: this.form.add2,
          add3: this.form.add3,
          company_add1: this.form.billAdd1,
          company_add2: this.form.billAdd2,
          company_add3: this.form.billAdd3,
          company_name: this.form.compName,
          credit_terms: this.form.credit_terms,
          accno: this.form.accno,
          notes: this.form.notes,
          product_id: this.input.product_name.sku,
          quantity: this.input.qty ? this.input.qty : null,
          quantity_type: this.input.qtyType ? this.input.qtyType : null,
          price: price !== null ? price.toFixed(4) : "",
          pro_stock_id: null
        };
      }

      let post;
      if (
        data === "save" &&
        (this.error.outlet_name ||
          this.error.date ||
          this.error.outlet_cat ||
          this.error.sub_outlet_cat ||
          this.error.idno ||
          this.error.typeoutlet)
      ) {
        post = false;
      } else if (
        data === "add" &&
        (this.error.outlet_name ||
          this.error.date ||
          this.error.outlet_cat ||
          this.error.product_name ||
          this.error.qty ||
          this.error.qtyType ||
          this.error.price)
      ) {
        post = false;
      } else {
        post = true;
      }

      if (post) {
        this.$store.dispatch("postStockout", form).then(res => {
          if (res.data.response.code === 1) {
            this.ui.stockUp = false;
            this.form.stock_id = res.data.data.stock_id;
            let price = 0;
            this.items = [];
            res.data.data.pro_stock.forEach(element => {
              let defPrice = parseFloat(element.total_price_pu);
              price += defPrice;
              this.items.push({
                pro_stock_id: element.pro_stock_id,
                product_name: element.product.name,
                sku: element.product_id,
                quantity: element.quantity,
                qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn",
                price: element.price,
                totalprice: element.total_price_pu
              });
            });
            this.grandP = price;
          }
        });
      }
    },
    onClickAdd(data) {
      this.onClickSave(data);
      // this.checkForm();
      // let grandTotalPrice = 0;
      let post;
      if (
        data === "add" &&
        (this.error.outlet_name ||
          this.error.date ||
          this.error.outlet_cat ||
          this.error.product_name ||
          this.error.qty ||
          this.error.qtyType ||
          this.error.price)
      ) {
        post = false;
      } else {
        post = true;
      }

      if (post) {
        let price = parseFloat(this.input.price);
        let totalPrice = parseFloat(this.totalPrice);

        this.grandP = parseFloat(this.grandP) + totalPrice;

        this.items.push({
          isActive: true,
          product_name: this.input.product_name.name,
          sku: this.input.product_name.sku,
          index: this.input.product_name.index,
          quantity: this.input.qty,
          qtyType: this.input.qtyType === 1 ? "Pcs" : "Ctn",
          price: price.toFixed(2),
          totalprice: totalPrice.toFixed(4)
        });
        this.input.product_name = "";
        this.input.qty = "";
        this.input.qtyType = "1";
        this.input.price = "";
      }
    },
    getProduct() {
      // let param = "?type=" + this.$route.query.pro_cat;
      this.isLoading = true;
      this.product_name = [];
      this.$store.dispatch("getProduct").then(res => {
        this.isLoading = false;
        res.data.data.forEach((element, index) => {
          this.product_name.push({
            sku: element.product_id,
            name: element.name,
            index: index
          });
        });
      });
    },
    nameWithSKU({ name, sku }) {
      return `${name} — [${sku}]`;
    },
    deleteItem(index) {
      this.$store
        .dispatch("deleteProMF", this.items[index].pro_stock_id)
        .then(res => {
          if (res.data.response.code === 1) {
            this.grandP =
              parseFloat(this.grandP) - this.items[index].totalprice;
            this.items.splice(index, 1);
          }
        });
    },
    async getOutlet() {
      await this.$store.dispatch("getOutlet").then(res => {
        if (res.data.response.code === 100) {
          this.suboutlet_cat = [];
          this.typeoutlet = [];
          this.outlet_cat = [{ text: "Please Select", value: "" }];
          res.data.data.forEach((element, index) => {
            let outlet_temp = [{ text: "Please Select", value: "" }];
            let typeoutlet_temp = [{ text: "Please Select", value: "" }];

            if (element.sub_outlet.length >= 1) {
              element.sub_outlet.forEach(item => {
                outlet_temp.push({
                  value: item.sub_outlet_id,
                  text: item.name
                });
              });
            }

            this.outlet_cat.push({
              value: element.outlet_id,
              text: element.name,
              index: index
            });
            if (element.typeoutlet.length >= 1) {
              element.typeoutlet.forEach(item => {
                typeoutlet_temp.push({
                  value: item.sub_outlet_id,
                  text: item.name
                });
              });
            }

            this.suboutlet_cat.push(outlet_temp);
            this.typeoutlet.push(typeoutlet_temp);
          });
        }
        if (this.$route.query.type === "update") {
          this.showStockout();
        }
        this.$forceUpdate();
      });
    },
    changeOutlet() {
      this.form.suboutlet_cat = "";
      this.form.typeoutlet = "";
      this.form.idno = "";
      const find = this.outlet_cat.find(
        element => element.value === this.form.outlet_cat
      );

      this.selectOutlet.suboutlet_cat = this.suboutlet_cat[find.index];
      this.selectOutlet.typeoutlet = this.typeoutlet[find.index];

      if (this.selectOutlet.suboutlet_cat.length >= 1) {
        this.form.suboutlet_cat = this.selectOutlet.suboutlet_cat[0].value;
      }
      if (this.selectOutlet.typeoutlet.length >= 1) {
        this.form.typeoutlet = this.selectOutlet.typeoutlet[0].value;
      }
    },
    onClickPreview() {
      if (this.items.length < 1) {
        this.checkForm();
      }

      this.$router.push({
        path: `stockout_user_submit?id=${this.form.stock_id}`
      });
    },
    checkForm(e) {
      this.error.outlet_name = "";
      this.error.outlet_cat = "";
      this.error.sub_outlet_cat = "";
      this.error.product_name = "";
      this.error.date = "";
      this.error.qty = "";
      this.error.qtyType = "";
      this.error.price = "";
      this.error.idno = "";
      this.error.typeoutlet = "";

      if (e === "save") {
        // Check SubOutlet
        if (this.selectOutlet.suboutlet_cat.length > 1) {
          if (!this.form.suboutlet_cat) {
            this.error.sub_outlet_cat = "Sub outlet category is required";
          }
        }

        // Check Type outlet
        if (this.selectOutlet.typeoutlet.length > 1) {
          if (!this.form.typeoutlet) {
            this.error.typeoutlet = "Category type is required";
          }
        }

        // Check id no
        if (!this.form.idno && this.form.outlet_cat === 6)
          this.error.idno = "ID number is required.";

        if (this.form.outlet_cat && this.form.outlet_name && this.form.date)
          return true;
        if (!this.form.outlet_cat)
          this.error.outlet_cat = "Outlet Category required.";
        if (!this.form.outlet_name)
          this.error.outlet_name = "Outlet Name required.";
        if (!this.form.date) this.error.date = "Date required.";
      } else {
        if (
          this.form.outlet_cat &&
          this.form.outlet_name &&
          this.form.date &&
          this.input.product_name &&
          this.input.qty &&
          this.input.price
        )
          return true;

        if (!this.form.outlet_cat)
          this.error.outlet_cat = "Outlet Category required.";

        if (!this.form.outlet_name)
          this.error.outlet_name = "Outlet Name required.";
        if (!this.form.date) this.error.date = "Date required.";
        if (!this.input.product_name)
          this.error.product_name = "Product Name required.";
        if (!this.input.qty) this.error.qty = "Quantity required.";
        if (!this.input.qtyType) this.error.qtyType = "Quantity Type required.";
        if (!this.input.price) this.error.price = "Price required.";
      }
      // e.preventDefault();
    },
    onClickBack() {
      localStorage.removeItem("data_stockout");
      // this.$router.go(-1);
      if (
        this.$route.query.type === "new" ||
        (this.$route.query.type === "update" &&
          this.$route.query.from !== "update")
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: `stockout_user`
        });
      }
    },
    // New Outlet
    itemSelected(item) {
      this.form.outlet_name = item.name;
    },
    setLabel(item) {
      return item.name;
    },
    inputChange(text) {
      // your search method
      this.items = this.items.filter(item => item.name.contains(text));
      // now `items` will be showed in the suggestion list
    },
    toggleOutlet() {
      if (this.chooseType == "2") {
        this.chooseType = "1";
        this.nameType = "Select Outlet";
      } else {
        this.chooseType = "2";
        this.nameType = "Add New Outlet";
      }
      this.form.outlet_name = "";
      this.item = {};
    },
    async showStockout() {
      this.isLoading = true;
      // this.getOutlet();

      await this.$store
        .dispatch("showStockout", { stock_id: this.$route.query.stockid })
        .then(res => {
          let price = 0;
          this.items = [];

          if (res.data.response.code === 100) {
            this.isLoading = false;
            let stock = res.data.data;
            this.form.stock_id = this.$route.query.stockid;
            this.form.outlet_name = stock.outlethistory.outlet_name;
            this.form.outlet_cat = stock.outlet_id;
            this.form.suboutlet_cat = stock.sub_outlet_id
              ? stock.sub_outlet_id
              : "";
            this.form.idno = stock.idno;

            if (this.isSafari) {
              this.form.date = moment(stock.date).format("DD/MM/YYYY");
            } else {
              this.form.date = moment(stock.date).format("YYYY-MM-DD");
            }

            this.form.category = "";
            this.form.typeoutlet = stock.sub_outlet_type
              ? stock.sub_outlet_type
              : "";
            this.form.chiller = stock.chiller;
            this.form.faxno = stock.outlethistory.faxno;
            this.form.telno = stock.outlethistory.telno;
            this.form.add1 = stock.outlethistory.add1;
            this.form.add2 = stock.outlethistory.add2;
            this.form.add3 = stock.outlethistory.add3;
            this.form.notes = stock.outlethistory.notes;
            this.form.billAdd1 = stock.company_add1;
            this.form.billAdd2 = stock.company_add2;
            this.form.billAdd3 = stock.company_add3;
            this.form.compName = stock.company_name;
            this.form.credit_terms = stock.credit_terms;
            this.form.accno = stock.accno;

            stock.pro_stock.forEach(element => {
              let defPrice = parseFloat(element.total_price_pu);
              price += defPrice;
              this.items.push({
                pro_stock_id: element.pro_stock_id,
                product_name: element.product.name,
                sku: element.product_id,
                quantity: element.quantity,
                qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn",
                price: element.price,
                totalprice: element.total_price_pu
              });
            });
            this.grandP = price;

            const find = this.outlet_cat.find(
              element => parseInt(element.value) === parseInt(stock.outlet_id)
            );

            this.selectOutlet.suboutlet_cat = this.suboutlet_cat[find.index];
            this.selectOutlet.typeoutlet = this.typeoutlet[find.index];
          }
        });
    },
    getOutletNameHistory() {
      this.select = [];
      this.isLoading = true;
      this.$store.dispatch("getOutletName").then(res => {
        this.isLoading = false;
        this.outletHistory = [];
        if (res.data.data.length >= 1) {
          res.data.data.forEach(item => {
            this.outletHistory.push(item);
            this.select.push(item.outlet_name);
          });
          this.disableBtn = false;
          this.select.push("Add new outlet");
        } else {
          this.disableBtn = true;
          this.select.push("Add new outlet");
        }
      });
    },
    changeOutletInfo() {
      if (this.form.outlet_name === "Add new outlet") {
        this.chooseType = 1;
        this.form.outlet_name = "";
      } else {
        let data = this.outletHistory.find(
          element => element.outlet_name == this.form.outlet_name
        );
        this.form.faxno = data.faxno;
        this.form.telno = data.telno;
        this.form.add1 = data.add1;
        this.form.add2 = data.add2;
        this.form.add3 = data.add3;
        this.form.notes = data.notes;
      }
    },
    onClickClear() {
      this.input = {
        product_name: [],
        qty: "",
        qtyType: "1",
        price: ""
      };
    }
  }
};
</script>
<style lang="css" scoped></style>
